import Marquee from "react-fast-marquee";

// TODO: replace each name below with a real client logo image once available
const brands = ["Google", "Meta", "Spotify", "Airbnb", "Nike", "Amazon"];

export function ClientLogosSection() {
  return (
    <section
      data-testid="client-logos-section"
      className="py-16 md:py-20 bg-black border-t border-white/10 overflow-hidden"
    >
      <Marquee speed={24} gradient={false} autoFill>
        {brands.map((brand, i) => (
          <span
            key={brand + i}
            data-testid={`client-logo-${i}`}
            className="font-display font-bold text-xl md:text-2xl tracking-tight text-zinc-500 hover:text-violet-400 transition-colors duration-300 cursor-default select-none mx-10 md:mx-14"
          >
            {brand}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
